export enum DocumentStatus {
  COMPLETE = 'COMPLETE',
  MISSING = 'MISSING',
  EXPIRED = 'EXPIRED',
  NOT_REQUIRED = 'NOT_REQUIRED',
}

export enum DocumentType {
  FORM = 'FORM',
  DOCUMENT = 'DOCUMENT',
}

export type ClinicDocument = {
  entityReferenceId: string | null
  step: string
  status: DocumentStatus
  submitDate: string | null
  type: DocumentType
  requiresSignature: boolean
  signatureDocumentUrl: string | null
}

export type DocumentsClinic = {
  referenceId: string
  name: string
  officialName: string
  city: string
  street: string
  houseNumber: string
  zipCode: string
  phone: string
  email: string
  clinicLogoUrl: string
  webSiteUrl: string
  privacyPolicyUrl: string
  termsAndConditionsUrl: string
  type: string
}

export type ClinicDocuments = {
  clinic: DocumentsClinic
  anamnesisState: ClinicDocument[]
}

export type DocumentHistoryEntry = {
  referenceId: string
  step: string
  submitDate: string | null
  signed: boolean
  valid: boolean
  expired: boolean
}
